import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getSubscription } from "./api";

const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setSubscription(null);
      setLoading(false);
      return;
    }
    getSubscription()
      .then(({ data }) => setSubscription(data))
      .catch(() => setSubscription(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
    const onAuth = () => setTimeout(refresh, 300);
    window.addEventListener("storage", onAuth);
    return () => window.removeEventListener("storage", onAuth);
  }, [refresh]);

  return (
    <SubscriptionContext.Provider value={{ subscription, loading, refresh }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  return useContext(SubscriptionContext);
}

export function canUse(subscription, resource) {
  if (!subscription || !subscription.usage) return { allowed: true, used: 0, limit: 999 };
  const entry = subscription.usage[resource];
  if (!entry) return { allowed: true, used: 0, limit: 999 };
  return {
    allowed: entry.used < entry.limit,
    used: entry.used,
    limit: entry.limit,
    percentage: entry.limit > 0 ? Math.round((entry.used / entry.limit) * 100) : 0,
  };
}
